/*

DO NOT UPDATE

This version is required for detectizr/Revealizr

*/


/*! modernizr 3.1.0 (Custom Build) | MIT *
 * http://modernizr.com/download/?-backgroundblendmode-bgsizecover-cssanimations-csscalc-cssgradients-csstransforms-csstransitions-flexbox-hashchange-opacity-pointerevents-svg-svgasimg-video-videoautoplay-videoloop-videopreload-mq !*/
!function (A, e, t) {
    function n(A) {
        var e = T.className, t = Modernizr._config.classPrefix || "";
        if (B && (e = e.baseVal), Modernizr._config.enableJSClass) {
            var n = new RegExp("(^|\\s)" + t + "no-js(\\s|$)");
            e = e.replace(n, "$1" + t + "js$2")
        }
        Modernizr._config.enableClasses && (e += " " + t + A.join(" " + t), B ? T.className.baseVal = e : T.className = e)
    }

    function o(A, e) {
        return typeof A === e
    }

    function r() {
        var A, e, t, n, r, i, a;
        for (var s in R) {
            if (A = [], e = R[s], e.name && (A.push(e.name.toLowerCase()), e.options && e.options.aliases && e.options.aliases.length)) for (t = 0; t < e.options.aliases.length; t++) A.push(e.options.aliases[t].toLowerCase());
            for (n = o(e.fn, "function") ? e.fn() : e.fn, r = 0; r < A.length; r++) i = A[r], a = i.split("."), 1 === a.length ? Modernizr[a[0]] = n : (!Modernizr[a[0]] || Modernizr[a[0]] instanceof Boolean || (Modernizr[a[0]] = new Boolean(Modernizr[a[0]])), Modernizr[a[0]][a[1]] = n), E.push((n ? "" : "no-") + a.join("-"))
        }
    }

    function i() {
        return "function" != typeof e.createElement ? e.createElement(arguments[0]) : B ? e.createElementNS.call(e, "http://www.w3.org/2000/svg", arguments[0]) : e.createElement.apply(e, arguments)
    }

    function a() {
        var A = e.body;
        return A || (A = i(B ? "svg" : "body"), A.fake = !0), A
    }

    function s(A, t, n, o) {
        var r, s, l, c, d = "modernizr", u = i("div"), f = a();
        if (parseInt(n, 10)) for (; n--;) l = i("div"), l.id = o ? o[n] : d + (n + 1), u.appendChild(l);
        return r = i("style"), r.type = "text/css", r.id = "s" + d, (f.fake ? f : u).appendChild(r), f.appendChild(u), r.styleSheet ? r.styleSheet.cssText = A : r.appendChild(e.createTextNode(A)), u.id = d, f.fake && (f.style.background = "", f.style.overflow = "hidden", c = T.style.overflow, T.style.overflow = "hidden", T.appendChild(f)), s = t(u, A), f.fake ? (f.parentNode.removeChild(f), T.style.overflow = c, T.offsetHeight) : u.parentNode.removeChild(u), !!s
    }

    function l(A) {
        return A.replace(/([a-z])-([a-z])/g, function (A, e, t) {
            return e + t.toUpperCase()
        }).replace(/^-/, "")
    }

    function c(A, e) {
        if ("object" == typeof A) for (var t in A) G(A, t) && c(t, A[t]); else {
            A = A.toLowerCase();
            var o = A.split("."), r = Modernizr[o[0]];
            if (2 == o.length && (r = r[o[1]]), "undefined" != typeof r) return Modernizr;
            e = "function" == typeof e ? e() : e, 1 == o.length ? Modernizr[o[0]] = e : (!Modernizr[o[0]] || Modernizr[o[0]] instanceof Boolean || (Modernizr[o[0]] = new Boolean(Modernizr[o[0]])), Modernizr[o[0]][o[1]] = e), n([(e && 0 != e ? "" : "no-") + o.join("-")]), Modernizr._trigger(A, e)
        }
        return Modernizr
    }

    function d(A, e) {
        return function () {
            return A.apply(e, arguments)
        }
    }

    function u(A, e, t) {
        var n;
        for (var r in A) if (A[r] in e) return t === !1 ? A[r] : (n = e[A[r]], o(n, "function") ? d(n, t || e) : n);
        return !1
    }

    function f(A, e) {
        return !!~("" + A).indexOf(e)
    }

    function p(A) {
        return A.replace(/([A-Z])/g, function (A, e) {
            return "-" + e.toLowerCase()
        }).replace(/^ms-/, "-ms-")
    }

    function g(e, n) {
        var o = e.length;
        if ("CSS" in A && "supports" in A.CSS) {
            for (; o--;) if (A.CSS.supports(p(e[o]), n)) return !0;
            return !1
        }
        if ("CSSSupportsRule" in A) {
            for (var r = []; o--;) r.push("(" + p(e[o]) + ":" + n + ")");
            return r = r.join(" or "), s("@supports (" + r + ") { #modernizr { position: absolute; } }", function (A) {
                return "absolute" == getComputedStyle(A, null).position
            })
        }
        return t
    }

    function h(A, e, n, r) {
        function a() {
            c && (delete Y.style, delete Y.modElem)
        }

        if (r = o(r, "undefined") ? !1 : r, !o(n, "undefined")) {
            var s = g(A, n);
            if (!o(s, "undefined")) return s
        }
        for (var c, d, u, p, h, m = ["modernizr", "tspan"]; !Y.style;) c = !0, Y.modElem = i(m.shift()), Y.style = Y.modElem.style;
        for (u = A.length, d = 0; u > d; d++) if (p = A[d], h = Y.style[p], f(p, "-") && (p = l(p)), Y.style[p] !== t) {
            if (r || o(n, "undefined")) return a(), "pfx" == e ? p : !0;
            try {
                Y.style[p] = n
            } catch (v) {
            }
            if (Y.style[p] != h) return a(), "pfx" == e ? p : !0
        }
        return a(), !1
    }

    function m(A, e, t, n, r) {
        var i = A.charAt(0).toUpperCase() + A.slice(1), a = (A + " " + Q.join(i + " ") + i).split(" ");
        return o(e, "string") || o(e, "undefined") ? h(a, e, n, r) : (a = (A + " " + U.join(i + " ") + i).split(" "), u(a, e, t))
    }

    function v(A, e, n) {
        return m(A, t, t, e, n)
    }

    var E = [], R = [], w = {
        _version: "3.1.0",
        _config: {classPrefix: "", enableClasses: !0, enableJSClass: !0, usePrefixes: !0},
        _q: [],
        on: function (A, e) {
            var t = this;
            setTimeout(function () {
                e(t[A])
            }, 0)
        },
        addTest: function (A, e, t) {
            R.push({name: A, fn: e, options: t})
        },
        addAsyncTest: function (A) {
            R.push({name: null, fn: A})
        }
    }, Modernizr = function () {
    };
    Modernizr.prototype = w, Modernizr = new Modernizr, Modernizr.addTest("svg", !!e.createElementNS && !!e.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect);
    var T = e.documentElement, B = "svg" === T.nodeName.toLowerCase();
    Modernizr.addTest("video", function () {
        var A = i("video"), e = !1;
        try {
            (e = !!A.canPlayType) && (e = new Boolean(e), e.ogg = A.canPlayType('video/ogg; codecs="theora"').replace(/^no$/, ""), e.h264 = A.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/, ""), e.webm = A.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/, ""), e.vp9 = A.canPlayType('video/webm; codecs="vp9"').replace(/^no$/, ""), e.hls = A.canPlayType('application/x-mpegURL; codecs="avc1.42E01E"').replace(/^no$/, ""))
        } catch (t) {
        }
        return e
    }), Modernizr.addTest("videoloop", "loop" in i("video")), Modernizr.addTest("videopreload", "preload" in i("video"));
    var y = function (A) {
        function t(e, t) {
            var o;
            return e ? (t && "string" != typeof t || (t = i(t || "div")), e = "on" + e, o = e in t, !o && n && (t.setAttribute || (t = i("div")), t.setAttribute(e, ""), o = "function" == typeof t[e], t[e] !== A && (t[e] = A), t.removeAttribute(e)), o) : !1
        }

        var n = !("onblur" in e.documentElement);
        return t
    }();
    w.hasEvent = y, Modernizr.addTest("hashchange", function () {
        return y("hashchange", A) === !1 ? !1 : e.documentMode === t || e.documentMode > 7
    });
    var C = w._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : [];
    w._prefixes = C, Modernizr.addTest("csscalc", function () {
        var A = "width:", e = "calc(10px);", t = i("a");
        return t.style.cssText = A + C.join(e + A), !!t.style.length
    }), Modernizr.addTest("cssgradients", function () {
        var A = "background-image:", e = "gradient(linear,left top,right bottom,from(#9f9),to(white));", t = "linear-gradient(left top,#9f9, white);", n = A + C.join(t + A).slice(0, -A.length);
        Modernizr._config.usePrefixes && (n += A + "-webkit-" + e);
        var o = i("a"), r = o.style;
        return r.cssText = n, ("" + r.backgroundImage).indexOf("gradient") > -1
    }), Modernizr.addTest("opacity", function () {
        var A = i("a").style;
        return A.cssText = C.join("opacity:.55;"), /^0.55$/.test(A.opacity)
    });
    var F = function () {
        var e = A.matchMedia || A.msMatchMedia;
        return e ? function (A) {
            var t = e(A);
            return t && t.matches || !1
        } : function (e) {
            var t = !1;
            return s("@media " + e + " { #modernizr { position: absolute; } }", function (e) {
                t = "absolute" == (A.getComputedStyle ? A.getComputedStyle(e, null) : e.currentStyle).position
            }), t
        }
    }();
    w.mq = F;
    var x = "Moz O ms Webkit", U = w._config.usePrefixes ? x.toLowerCase().split(" ") : [];
    w._domPrefixes = U, Modernizr.addTest("pointerevents", function () {
        var A = !1, e = U.length;
        for (A = Modernizr.hasEvent("pointerdown"); e-- && !A;) y(U[e] + "pointerdown") && (A = !0);
        return A
    });
    var G;
    !function () {
        var A = {}.hasOwnProperty;
        G = o(A, "undefined") || o(A.call, "undefined") ? function (A, e) {
            return e in A && o(A.constructor.prototype[e], "undefined")
        } : function (e, t) {
            return A.call(e, t)
        }
    }(), w._l = {}, w.on = function (A, e) {
        this._l[A] || (this._l[A] = []), this._l[A].push(e), Modernizr.hasOwnProperty(A) && setTimeout(function () {
            Modernizr._trigger(A, Modernizr[A])
        }, 0)
    }, w._trigger = function (A, e) {
        if (this._l[A]) {
            var t = this._l[A];
            setTimeout(function () {
                var A, n;
                for (A = 0; A < t.length; A++) (n = t[A])(e)
            }, 0), delete this._l[A]
        }
    }, Modernizr._q.push(function () {
        w.addTest = c
    }), Modernizr.addTest("svgasimg", e.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#Image", "1.1")), Modernizr.addAsyncTest(function () {
        function A(t) {
            clearTimeout(e), n.removeEventListener("playing", A, !1), c("videoautoplay", t && "playing" === t.type || 0 !== n.currentTime), n.parentNode.removeChild(n)
        }

        var e, t = 300, n = i("video"), o = n.style;
        if (!(Modernizr.video && "autoplay" in n)) return void c("videoautoplay", !1);
        o.position = "absolute", o.height = 0, o.width = 0;
        try {
            if (Modernizr.video.ogg) n.src = "data:video/ogg;base64,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"; else {
                if (!Modernizr.video.h264) return void c("videoautoplay", !1);
                n.src = "data:video/mp4;base64,AAAAHGZ0eXBtcDQyAAAAAG1wNDJpc29tYXZjMQAAAz5tb292AAAAbG12aGQAAAAAzaNacc2jWnEAAV+QAAFfkAABAAABAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAAAAGGlvZHMAAAAAEICAgAcAT////3//AAACQ3RyYWsAAABcdGtoZAAAAAHNo1pxzaNacQAAAAEAAAAAAAFfkAAAAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAEAAAAAAEAAAABAAAAAAAd9tZGlhAAAAIG1kaGQAAAAAzaNacc2jWnEAAV+QAAFfkFXEAAAAAAAhaGRscgAAAAAAAAAAdmlkZQAAAAAAAAAAAAAAAAAAAAGWbWluZgAAABR2bWhkAAAAAQAAAAAAAAAAAAAAJGRpbmYAAAAcZHJlZgAAAAAAAAABAAAADHVybCAAAAABAAABVnN0YmwAAACpc3RzZAAAAAAAAAABAAAAmWF2YzEAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAEAAQAEgAAABIAAAAAAAAAAEOSlZUL0FWQyBDb2RpbmcAAAAAAAAAAAAAAAAAAAAAAAAY//8AAAAxYXZjQwH0AAr/4QAZZ/QACq609NQYBBkAAAMAAQAAAwAKjxImoAEABWjOAa8gAAAAEmNvbHJuY2xjAAYAAQAGAAAAGHN0dHMAAAAAAAAAAQAAAAUAAEZQAAAAKHN0c3oAAAAAAAAAAAAAAAUAAAIqAAAACAAAAAgAAAAIAAAACAAAAChzdHNjAAAAAAAAAAIAAAABAAAABAAAAAEAAAACAAAAAQAAAAEAAAAYc3RjbwAAAAAAAAACAAADYgAABaQAAAAUc3RzcwAAAAAAAAABAAAAAQAAABFzZHRwAAAAAAREREREAAAAb3VkdGEAAABnbWV0YQAAAAAAAAAhaGRscgAAAAAAAAAAbWRpcgAAAAAAAAAAAAAAAAAAAAA6aWxzdAAAADKpdG9vAAAAKmRhdGEAAAABAAAAAEhhbmRCcmFrZSAwLjkuOCAyMDEyMDcxODAwAAACUm1kYXQAAAHkBgX/4NxF6b3m2Ui3lizYINkj7u94MjY0IC0gY29yZSAxMjAgLSBILjI2NC9NUEVHLTQgQVZDIGNvZGVjIC0gQ29weWxlZnQgMjAwMy0yMDExIC0gaHR0cDovL3d3dy52aWRlb2xhbi5vcmcveDI2NC5odG1sIC0gb3B0aW9uczogY2FiYWM9MCByZWY9MSBkZWJsb2NrPTE6MDowIGFuYWx5c2U9MHgxOjAgbWU9ZXNhIHN1Ym1lPTkgcHN5PTAgbWl4ZWRfcmVmPTAgbWVfcmFuZ2U9NCBjaHJvbWFfbWU9MSB0cmVsbGlzPTAgOHg4ZGN0PTAgY3FtPTAgZGVhZHpvbmU9MjEsMTEgZmFzdF9wc2tpcD0wIGNocm9tYV9xcF9vZmZzZXQ9MCB0aHJlYWRzPTYgc2xpY2VkX3RocmVhZHM9MCBucj0wIGRlY2ltYXRlPTEgaW50ZXJsYWNlZD0wIGJsdXJheV9jb21wYXQ9MCBjb25zdHJhaW5lZF9pbnRyYT0wIGJmcmFtZXM9MCB3ZWlnaHRwPTAga2V5aW50PTUwIGtleWludF9taW49NSBzY2VuZWN1dD00MCBpbnRyYV9yZWZyZXNoPTAgcmM9Y3FwIG1idHJlZT0wIHFwPTAAgAAAAD5liISscR8A+E4ACAACFoAAITAAAgsAAPgYCoKgoC+L4vi+KAvi+L4YfAEAACMzgABF9AAEUGUgABDJiXnf4AAAAARBmiKUAAAABEGaQpQAAAAEQZpilAAAAARBmoKU"
            }
        } catch (r) {
            return void c("videoautoplay", !1)
        }
        n.setAttribute("autoplay", ""), n.style.cssText = "display:none", T.appendChild(n), setTimeout(function () {
            n.addEventListener("playing", A, !1), e = setTimeout(A, t)
        }, 0)
    });
    var Q = w._config.usePrefixes ? x.split(" ") : [];
    w._cssomPrefixes = Q;
    var V = function (e) {
        var n, o = C.length, r = A.CSSRule;
        if ("undefined" == typeof r) return t;
        if (!e) return !1;
        if (e = e.replace(/^@/, ""), n = e.replace(/-/g, "_").toUpperCase() + "_RULE", n in r) return "@" + e;
        for (var i = 0; o > i; i++) {
            var a = C[i], s = a.toUpperCase() + "_" + n;
            if (s in r) return "@-" + a.toLowerCase() + "-" + e
        }
        return !1
    };
    w.atRule = V;
    var b = {elem: i("modernizr")};
    Modernizr._q.push(function () {
        delete b.elem
    });
    var Y = {style: b.elem.style};
    Modernizr._q.unshift(function () {
        delete Y.style
    }), w.testAllProps = m, w.testAllProps = v, Modernizr.addTest("cssanimations", v("animationName", "a", !0)), Modernizr.addTest("flexbox", v("flexBasis", "1px", !0)), Modernizr.addTest("bgsizecover", v("backgroundSize", "cover")), Modernizr.addTest("csstransforms", function () {
        return -1 === navigator.userAgent.indexOf("Android 2.") && v("transform", "scale(1)", !0)
    }), Modernizr.addTest("csstransitions", v("transition", "all", !0));
    var Z = w.prefixed = function (A, e, t) {
        return 0 === A.indexOf("@") ? V(A) : (-1 != A.indexOf("-") && (A = l(A)), e ? m(A, e, t) : m(A, "pfx"))
    };
    Modernizr.addTest("backgroundblendmode", Z("backgroundBlendMode", "text")), r(), n(E), delete w.addTest, delete w.addAsyncTest;
    for (var k = 0; k < Modernizr._q.length; k++) Modernizr._q[k]();
    A.Modernizr = Modernizr
}(window, document);


/*! Detectizr v2.2.0 | (c) 2012 Baris Aydinoglu | Licensed  */
window.Detectizr = function (a, b, c, d) {
    var e = {}, f = a.Modernizr, g = ["tv", "tablet", "mobile", "desktop"], h = {
        addAllFeaturesAsClass: !1,
        detectDevice: !0,
        detectDeviceModel: !0,
        detectScreen: !0,
        detectOS: !0,
        detectBrowser: !0,
        detectPlugins: !0
    }, i = [{
        name: "adobereader",
        substrs: ["Adobe", "Acrobat"],
        progIds: ["AcroPDF.PDF", "PDF.PDFCtrl.5"]
    }, {name: "flash", substrs: ["Shockwave Flash"], progIds: ["ShockwaveFlash.ShockwaveFlash.1"]}, {
        name: "wmplayer",
        substrs: ["Windows Media"],
        progIds: ["wmplayer.ocx"]
    }, {name: "silverlight", substrs: ["Silverlight"], progIds: ["AgControl.AgControl"]}, {
        name: "quicktime",
        substrs: ["QuickTime"],
        progIds: ["QuickTime.QuickTime"]
    }], j = /[\t\r\n]/g, k = c.documentElement, l, m;

    function n(a, b) {
        var c, d, e;
        if (arguments.length > 2) for (c = 1, d = arguments.length; d > c; c += 1) n(a, arguments[c]); else for (e in b) b.hasOwnProperty(e) && (a[e] = b[e]);
        return a
    }

    function o(a) {
        return e.browser.userAgent.indexOf(a) > -1
    }

    function p(a) {
        return a.test(e.browser.userAgent)
    }

    function q(a) {
        return a.exec(e.browser.userAgent)
    }

    function r(a) {
        return a.replace(/^\s+|\s+$/g, "")
    }

    function s(a) {
        return null === a || a === d ? "" : String(a).replace(/((\s|\-|\.)+[a-z0-9])/g, function (a) {
            return a.toUpperCase().replace(/(\s|\-|\.)/g, "")
        })
    }

    function t(a, b) {
        var c = b || "", d = 1 === a.nodeType && (a.className ? (" " + a.className + " ").replace(j, " ") : "");
        if (d) {
            while (d.indexOf(" " + c + " ") >= 0) d = d.replace(" " + c + " ", " ");
            a.className = b ? r(d) : ""
        }
    }

    function u(a, b, c) {
        a && (a = s(a), b && (b = s(b), v(a + b, !0), c && v(a + b + "_" + c, !0)))
    }

    function v(a, b) {
        a && f && (h.addAllFeaturesAsClass ? f.addTest(a, b) : (b = "function" == typeof b ? b() : b, b ? f.addTest(a, !0) : (delete f[a], t(k, a))))
    }

    function w(a, b) {
        a.version = b;
        var c = b.split(".");
        c.length > 0 ? (c = c.reverse(), a.major = c.pop(), c.length > 0 ? (a.minor = c.pop(), c.length > 0 ? (c = c.reverse(), a.patch = c.join(".")) : a.patch = "0") : a.minor = "0") : a.major = "0"
    }

    function x() {
        a.clearTimeout(l), l = a.setTimeout(function () {
            m = e.device.orientation, a.innerHeight > a.innerWidth ? e.device.orientation = "portrait" : e.device.orientation = "landscape", v(e.device.orientation, !0), m !== e.device.orientation && v(m, !1)
        }, 10)
    }

    function y(a) {
        var c = b.plugins, d, e, f, g, h;
        for (g = c.length - 1; g >= 0; g--) {
            for (d = c[g], e = d.name + d.description, f = 0, h = a.length; h >= 0; h--) -1 !== e.indexOf(a[h]) && (f += 1);
            if (f === a.length) return !0
        }
        return !1
    }

    function z(a) {
        var b;
        for (b = a.length - 1; b >= 0; b--) try {
            new ActiveXObject(a[b])
        } catch (c) {
        }
        return !1
    }

    function A(d) {
        var j, k, l, m, r, t, A;
        if (h = n({}, h, d || {}), h.detectDevice) {
            for (e.device = {
                type: "",
                model: "",
                orientation: ""
            }, l = e.device, p(/googletv|smarttv|smart-tv|internet.tv|netcast|nettv|appletv|boxee|kylo|roku|dlnadoc|roku|pov_tv|hbbtv|ce\-html/) ? (l.type = g[0], l.model = "smartTv") : p(/xbox|playstation.3|wii/) ? (l.type = g[0], l.model = "gameConsole") : p(/ip(a|ro)d/) ? (l.type = g[1], l.model = "ipad") : p(/tablet/) && !p(/rx-34/) || p(/folio/) ? (l.type = g[1], l.model = String(q(/playbook/) || "")) : p(/linux/) && p(/android/) && !p(/fennec|mobi|htc.magic|htcX06ht|nexus.one|sc-02b|fone.945/) ? (l.type = g[1], l.model = "android") : p(/kindle/) || p(/mac.os/) && p(/silk/) ? (l.type = g[1], l.model = "kindle") : p(/gt-p10|sc-01c|shw-m180s|sgh-t849|sch-i800|shw-m180l|sph-p100|sgh-i987|zt180|htc(.flyer|\_flyer)|sprint.atp51|viewpad7|pandigital(sprnova|nova)|ideos.s7|dell.streak.7|advent.vega|a101it|a70bht|mid7015|next2|nook/) || p(/mb511/) && p(/rutem/) ? (l.type = g[1], l.model = "android") : p(/bb10/) ? (l.type = g[1], l.model = "blackberry") : (l.model = q(/iphone|ipod|android|blackberry|opera mini|opera mobi|skyfire|maemo|windows phone|palm|iemobile|symbian|symbianos|fennec|j2me/), null !== l.model ? (l.type = g[2], l.model = String(l.model)) : (l.model = "", p(/bolt|fennec|iris|maemo|minimo|mobi|mowser|netfront|novarra|prism|rx-34|skyfire|tear|xv6875|xv6975|google.wireless.transcoder/) ? l.type = g[2] : p(/opera/) && p(/windows.nt.5/) && p(/htc|xda|mini|vario|samsung\-gt\-i8000|samsung\-sgh\-i9/) ? l.type = g[2] : p(/windows.(nt|xp|me|9)/) && !p(/phone/) || p(/win(9|.9|nt)/) || p(/\(windows 8\)/) ? l.type = g[3] : p(/macintosh|powerpc/) && !p(/silk/) ? (l.type = g[3], l.model = "mac") : p(/linux/) && p(/x11/) ? l.type = g[3] : p(/solaris|sunos|bsd/) ? l.type = g[3] : p(/cros/) ? l.type = g[3] : p(/bot|crawler|spider|yahoo|ia_archiver|covario-ids|findlinks|dataparksearch|larbin|mediapartners-google|ng-search|snappy|teoma|jeeves|tineye/) && !p(/mobile/) ? (l.type = g[3], l.model = "crawler") : l.type = g[2])), j = 0, k = g.length; k > j; j += 1) v(g[j], l.type === g[j]);
            h.detectDeviceModel && v(s(l.model), !0)
        }
        if (h.detectScreen && (l.screen = {}, f && f.mq && (f.mq("only screen and (max-width: 240px)") ? (l.screen.size = "veryVerySmall", v("veryVerySmallScreen", !0)) : f.mq("only screen and (max-width: 320px)") ? (l.screen.size = "verySmall", v("verySmallScreen", !0)) : f.mq("only screen and (max-width: 480px)") && (l.screen.size = "small", v("smallScreen", !0)), (l.type === g[1] || l.type === g[2]) && f.mq("only screen and (-moz-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)") && (l.screen.resolution = "high", v("highresolution", !0))), l.type === g[1] || l.type === g[2] ? (a.onresize = function (a) {
            x(a)
        }, x()) : (l.orientation = "landscape", v(l.orientation, !0))), h.detectOS && (e.os = {}, m = e.os, "" !== l.model && ("ipad" === l.model || "iphone" === l.model || "ipod" === l.model ? (m.name = "ios", w(m, (p(/os\s([\d_]+)/) ? RegExp.$1 : "").replace(/_/g, "."))) : "android" === l.model ? (m.name = "android", w(m, p(/android\s([\d\.]+)/) ? RegExp.$1 : "")) : "blackberry" === l.model ? (m.name = "blackberry", w(m, p(/version\/([^\s]+)/) ? RegExp.$1 : "")) : "playbook" === l.model && (m.name = "blackberry", w(m, p(/os ([^\s]+)/) ? RegExp.$1.replace(";", "") : ""))), m.name || (o("win") || o("16bit") ? (m.name = "windows", o("windows nt 10") ? w(m, "10") : o("windows nt 6.3") ? w(m, "8.1") : o("windows nt 6.2") || p(/\(windows 8\)/) ? w(m, "8") : o("windows nt 6.1") ? w(m, "7") : o("windows nt 6.0") ? w(m, "vista") : o("windows nt 5.2") || o("windows nt 5.1") || o("windows xp") ? w(m, "xp") : o("windows nt 5.0") || o("windows 2000") ? w(m, "2k") : o("winnt") || o("windows nt") ? w(m, "nt") : o("win98") || o("windows 98") ? w(m, "98") : (o("win95") || o("windows 95")) && w(m, "95")) : o("mac") || o("darwin") ? (m.name = "mac os", o("68k") || o("68000") ? w(m, "68k") : o("ppc") || o("powerpc") ? w(m, "ppc") : o("os x") && w(m, (p(/os\sx\s([\d_]+)/) ? RegExp.$1 : "os x").replace(/_/g, "."))) : o("webtv") ? m.name = "webtv" : o("x11") || o("inux") ? m.name = "linux" : o("sunos") ? m.name = "sun" : o("irix") ? m.name = "irix" : o("freebsd") ? m.name = "freebsd" : o("bsd") && (m.name = "bsd")), m.name && (v(m.name, !0), m.major && (u(m.name, m.major), m.minor && u(m.name, m.major, m.minor))), p(/\sx64|\sx86|\swin64|\swow64|\samd64/) ? m.addressRegisterSize = "64bit" : m.addressRegisterSize = "32bit", v(m.addressRegisterSize, !0)), h.detectBrowser && (r = e.browser, p(/opera|webtv/) || !p(/msie\s([\d\w\.]+)/) && !o("trident") ? o("firefox") ? (r.engine = "gecko", r.name = "firefox", w(r, p(/firefox\/([\d\w\.]+)/) ? RegExp.$1 : "")) : o("gecko/") ? r.engine = "gecko" : o("opera") ? (r.name = "opera", r.engine = "presto", w(r, p(/version\/([\d\.]+)/) ? RegExp.$1 : p(/opera(\s|\/)([\d\.]+)/) ? RegExp.$2 : "")) : o("konqueror") ? r.name = "konqueror" : o("edge") ? (r.engine = "webkit", r.name = "edge", w(r, p(/edge\/([\d\.]+)/) ? RegExp.$1 : "")) : o("chrome") ? (r.engine = "webkit", r.name = "chrome", w(r, p(/chrome\/([\d\.]+)/) ? RegExp.$1 : "")) : o("iron") ? (r.engine = "webkit", r.name = "iron") : o("crios") ? (r.name = "chrome", r.engine = "webkit", w(r, p(/crios\/([\d\.]+)/) ? RegExp.$1 : "")) : o("applewebkit/") ? (r.name = "safari", r.engine = "webkit", w(r, p(/version\/([\d\.]+)/) ? RegExp.$1 : "")) : o("mozilla/") && (r.engine = "gecko") : (r.engine = "trident", r.name = "ie", !a.addEventListener && c.documentMode && 7 === c.documentMode ? w(r, "8.compat") : p(/trident.*rv[ :](\d+)\./) ? w(r, RegExp.$1) : w(r, p(/trident\/4\.0/) ? "8" : RegExp.$1)), r.name && (v(r.name, !0), r.major && (u(r.name, r.major), r.minor && u(r.name, r.major, r.minor))), v(r.engine, !0), r.language = b.userLanguage || b.language, v(r.language, !0)), h.detectPlugins) {
            for (r.plugins = [], j = i.length - 1; j >= 0; j--) t = i[j], A = !1, a.ActiveXObject ? A = z(t.progIds) : b.plugins && (A = y(t.substrs)), A && (r.plugins.push(t.name), v(t.name, !0));
            b.javaEnabled() && (r.plugins.push("java"), v("java", !0))
        }
    }

    return e.detect = function (a) {
        return A(a)
    }, e.init = function () {
        e !== d && (e.browser = {userAgent: (b.userAgent || b.vendor || a.opera).toLowerCase()}, e.detect())
    }, e.init(), e
}(this, this.navigator, this.document);

/*! matchMedia() polyfill - Test a CSS media type/query in JS. Authors & copyright (c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas. Dual MIT/BSD license */
window.matchMedia = window.matchMedia || (function (e, f) {
    var c, a = e.documentElement, b = a.firstElementChild || a.firstChild, d = e.createElement("body"), g = e.createElement("div");
    g.id = "mq-test-1";
    g.style.cssText = "position:absolute;top:-100em";
    d.style.background = "none";
    d.appendChild(g);
    return function (h) {
        g.innerHTML = '&shy;<style media="' + h + '"> #mq-test-1 { width: 42px; }</style>';
        a.insertBefore(d, b);
        c = g.offsetWidth == 42;
        a.removeChild(d);
        return {matches: c, media: h}
    }
})(document);


// Activate Detectizr
Detectizr.detect({
    // option for enabling HTML classes of all features (not only the true features) to be added
    addAllFeaturesAsClass: false,
    // option for enabling detection of device
    detectDevice: true,
    // option for enabling detection of device model
    detectDeviceModel: true,
    // option for enabling detection of screen size
    detectScreen: true,
    // option for enabling detection of operating system type and version
    detectOS: true,
    // option for enabling detection of browser type and version
    detectBrowser: true,
    // option for enabling detection of common browser plugins
    detectPlugins: true
});

/*!
 * Revealizr - Detect features v2.0.0
 *
 * Plugin équipe Tink, combinant la librairie Modernizr et l'extension Detectizr,
 * en plus de manipulations personnalisée pour récupérer les détails du navigateur
 *
 * Navigateurs supportés : IE 10+, Tous les autres
 *
 * Création: MAL (2016) - Tink.ca
 * Original (v1.0.0): JMN (2014) - Tink.ca
 *
 * Licensed MIT
 */
var Revealizr = Revealizr || {};
(function (window, document, $) {
    "use strict";

    window.Revealizr = function () {
        var app = this;

        /*
         Ajout de class possible dans le HTML:
         - desktop-size
         - tablet-size
         - mobile-size
         - server-dev
         - server-int
         - server-qa
         - server-tac
         - egc
         - egc-content
         */

        // Déclaration des variables

        // first load
        app.isDetectFeatureFirstLoad = true;

        // device and breakpoints
        app.isTabletDevice = false;
        app.isTabletSize = false;
        app.isMobileDevice = false;
        app.isMobileSize = false;
        app.isDesktopDevice = false;
        app.isDesktopSize = false;
        app.isBrowserAndroid = false;
        app.isBrowserMac = false;
        app.isBrowserBlackberryMobile = false;
        app.deviceType = 'no-touch';
        //app.isTouchEventsSupported = false;

        // events
        app.resizeORorientation = '';
        app.clickORtouchend = '';
        app.swiping = false;

        // EGC CMS TINK
        app.isCmsEgc = false;
        app.isCmsEgcContent = false;

        // serrvers
        app.server = '';

        app.currentViewportSize = '';
        app.lastViewportSize = '';
        app.windowOrientation = '';

        app.breakpointMobileMaxWidth = '729';
        app.breakpointTabletMaxWidth = '1199';
        app.breakpointDesktopMinWidth = '1200';

        app.nativeAndroidMinimumChromeVersion = 40; // Version minimum du Chrome qu'utilise le navigateur natif d'Android

        // Sélecteurs
        app.$html = document.querySelector('html');
        app.$href = document.location.href;
        app.$objAgent = navigator.userAgent;
        app.$objFullVersion = '' + parseFloat(navigator.appVersion);

        // Valeurs
        app.htmlClasses = app.$html.getAttribute('class');

        // Fonctions
        app.hasClass = function (selector, classToCheck) {
            return selector.classList.contains(classToCheck);
        };

        app.detectFeatures = function () {
            "use strict";

            // Tableau d'ajout et de supression de classes dans la balise HTML
            app.arrayHtmlAdd = [];
            app.arrayHtmlRemove = [];

            /*
             * Lectures et vérifications
             */

            // Vérification du device
            if (app.hasClass(app.$html, 'desktop')) {
                app.isDesktopDevice = true;
                app.isTabletDevice = false;
                app.isMobileDevice = false;
            } else if (app.hasClass(app.$html, 'tablet')) {
                app.isDesktopDevice = false;
                app.isTabletDevice = true;
                app.isMobileDevice = false;
            } else if (app.hasClass(app.$html, 'mobile')) {
                app.isDesktopDevice = false;
                app.isTabletDevice = false;
                app.isMobileDevice = true;
            }

            // Vérification du breakpoint
            if (Modernizr.mq('only all and (max-width: ' + app.breakpointMobileMaxWidth + 'px)')) {
                app.isMobileSize = true;
                app.isTabletSize = false;
                app.isDesktopSize = false;
                app.arrayHtmlAdd.push('mobile-size');
                app.arrayHtmlRemove.push('tablet-size');
                app.arrayHtmlRemove.push('desktop-size');
            } else if (Modernizr.mq('only all and (max-width: ' + app.breakpointTabletMaxWidth + 'px)')) {
                app.isMobileSize = false;
                app.isTabletSize = true;
                app.isDesktopSize = false;
                app.arrayHtmlRemove.push('mobile-size');
                app.arrayHtmlAdd.push('tablet-size');
                app.arrayHtmlRemove.push('desktop-size');
            } else if (Modernizr.mq('only all and (min-width: ' + app.breakpointDesktopMinWidth + 'px)')) {
                app.isMobileSize = false;
                app.isTabletSize = false;
                app.isDesktopSize = true;
                app.arrayHtmlRemove.push('mobile-size');
                app.arrayHtmlRemove.push('tablet-size');
                app.arrayHtmlAdd.push('desktop-size');
            }

            // Si l'on n'est pas au premier chargement de la fonction detectFeatures(),
            // récupération du dernier -viewport size-
            if (app.isDetectFeatureFirstLoad === false) {
                app.lastViewportSize = app.currentViewportSize;
            }

            // Ensuite, vérification du -viewport size- en cours
            if (app.isMobileSize) {
                app.currentViewportSize = 'mobile-size';
            } else if (app.isTabletSize) {
                app.currentViewportSize = 'tablet-size';
            } else if (app.isDesktopSize) {
                app.currentViewportSize = 'desktop-size';
            }

            // Vérification de l'orientation du device
            if (app.hasClass(app.$html, 'portrait')) {
                app.windowOrientation = 'portrait';
            }
            if (app.hasClass(app.$html, 'landscape')) {
                app.windowOrientation = 'landscape';
            }

            // Vérification si l'on est sur Blackberry Mobile
            //
            if ((app.hasClass(app.$html, 'blackberry') || app.hasClass(app.$html, 'blackberry10')) && app.hasClass(app.$html, 'smallscreen')) {
                app.isBrowserBlackberryMobile = 'true';
                app.arrayHtmlAdd.push('mobile');
                app.arrayHtmlRemove.push('tablet');
            }

            // Vérification si l'on est sur Android
            if (app.hasClass(app.$html, 'android')) {
                app.isBrowserAndroid = true;
            }

            // Vérification si l'on est sur Apple Mac
            if (app.hasClass(app.$html, 'mac')) {
                app.isBrowserMac = true;
            }

            // Vérification si l'on est sur l'EGC (CMS)
            if (app.$href.indexOf('/site-web/') > -1) {
                app.isCmsEgc = true;
                app.arrayHtmlAdd.push('egc');
            }
            if (app.$href.indexOf('mode=content') > -1) {
                app.isCmsEgcContent = true;
                app.arrayHtmlAdd.push('egc-content');
            }

            // Vérification si nous sommes en DEV
            if (app.$href.indexOf('local.') > -1 || app.$href.indexOf('localhost') > -1 || app.$href.indexOf('.s2i.com') > -1) {
                app.server = 'dev';
                app.arrayHtmlAdd.push('server-dev');
            }

            // Vérification si nous sommes en INT
            if (app.$href.indexOf('.tinkint') > -1) {
                app.server = 'int';
                app.arrayHtmlAdd.push('server-int');
            }

            // Vérification si nous sommes en QA
            if (app.$href.indexOf('.tinkqa') > -1) {
                app.server = 'qa';
                app.arrayHtmlAdd.push('server-qa');
            }

            // Vérification si nous sommes en TAC
            if (app.$href.indexOf('.tinktac') > -1) {
                app.server = 'tac';
                app.arrayHtmlAdd.push('server-tac');
            }

            // Vérification si le device/navigateur supporte les -Touch Events-
            /*if ( app.hasClass(app.$html, 'touchevents') ) {
                app.isTouchEventsSupported = true;
            }*/

            // (typeof el.ongesturestart == "function")
            if (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) {
                app.deviceType = 'touch';
            }

            // Détection à savoir si on utilise -touchend- ou -click- et -resize- ou -orientationchange-
            if ((app.isMobileDevice || app.isTabletDevice) && !app.isTouchEventsSupported) {
                app.resizeORorientation = 'orientationchange';
                app.clickORtouchend = 'touchend';
            } else {
                app.resizeORorientation = 'resize';
                app.clickORtouchend = 'click';
            }


            /*
             * Vérification si l'on est sur le navigateur natif d'Android
             * Comme le navigateur natif d'Android est basé sur une version antérieur de Chrome ou Safari,
             * il faut le détecter pour permettre une facilité de déboguage du navigateur
             */

            // Si le navigateur natif d'Android utilise "Chrome"
            if ((app.objOffsetVersion = app.$objAgent.indexOf("Chrome")) !== -1 && app.isBrowserAndroid) {

                app.objFullVersion = app.$objAgent.substring(app.objOffsetVersion + 7, app.objOffsetVersion + 9);

                if (app.objFullVersion < app.nativeAndroidMinimumChromeVersion) {
                    app.oldAndroid = true;
                    app.arrayHtmlAdd.push('old-android');
                }
            }
            // Si le navigateur natif d'Android utilise "Safari"
            else if ((app.objOffsetVersion = app.$objAgent.indexOf("Safari")) !== -1 && app.isBrowserAndroid) {
                app.oldAndroid = true;
                app.arrayHtmlAdd.push('old-android');
            }


            /*
             * Écritures dans le DOM
             * Ajout et suppression de classes dans la balise HTML
             */
            app.arrayHtmlAdd.forEach(function (entry) {
                app.$html.classList.add(entry);
            });
            app.arrayHtmlRemove.forEach(function (entry) {
                app.$html.classList.remove(entry);
            });


            /*
             * Mettre la valeur -false- à la variable de vérification du premier chargement de la fonction
             */
            app.isDetectFeatureFirstLoad = false;
        }

        $(window).on('touchmove', function () {
            app.swiping = true;
        }).on('touchstart', function () {
            app.swiping = false;
        });
    };

    Revealizr = new Revealizr();
})(window, document, jQuery);


// À mettre en-haut complètement dans le script principal du site, celui qui s'occupe de charger le reste de vos scripts
// À utiliser avec UnderscoreJS pour mieux contrôler l'appel sur le -resize-
/*
// Appel de la fonction detectFeatures() de Revealizr
_.defer(Revealizr.detectFeatures);
$(window).on('resize', _.throttle(function () {
    "use strict";

    Revealizr.detectFeatures();
}, 200));
*/
